// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__-wd7S","inner":"Footer_inner__1W8aC","nextIcon":"Footer_nextIcon__VJrTX","innerLeft":"Footer_innerLeft__1fet-"};